var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("商家建档申请")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "申请单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.sa_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "sa_id", $$v)
                                    },
                                    expression: "form.sa_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "城市" },
                                    on: { change: _vm.setMarket },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "0", label: "全部" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.citys, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "市场"
                                    },
                                    on: { change: _vm.setChild },
                                    model: {
                                      value: _vm.form.father_market_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "father_market_id",
                                          $$v
                                        )
                                      },
                                      expression: "form.father_market_id"
                                    }
                                  },
                                  _vm._l(_vm.market, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.label,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "子市场"
                                    },
                                    model: {
                                      value: _vm.form.market_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "market_id", $$v)
                                      },
                                      expression: "form.market_id"
                                    }
                                  },
                                  _vm._l(_vm.child_market, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.label,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "品牌名" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.brand_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "brand_name", $$v)
                                    },
                                    expression: "form.brand_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "主风格"
                                    },
                                    model: {
                                      value: _vm.form.style,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "style", $$v)
                                      },
                                      expression: "form.style"
                                    }
                                  },
                                  _vm._l(_vm.styles, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.label,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家id" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_id", $$v)
                                    },
                                    expression: "form.supply_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "提审人" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.submit_admin,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "submit_admin", $$v)
                                    },
                                    expression: "form.submit_admin"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.status
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          multiple: "",
                                          placeholder: "状态"
                                        },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      _vm._l(_vm.status, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "提审时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.submit_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "submit_time", $$v)
                                    },
                                    expression: "form.submit_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "一审时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.first_check_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "first_check_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.first_check_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "二审时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.second_check_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "second_check_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.second_check_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.status
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "是否提前订阅",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.form.show_app,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "show_app", $$v)
                                          },
                                          expression: "form.show_app"
                                        }
                                      },
                                      _vm._l(_vm.showApp, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.status
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "粉丝状态",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.form.fans_status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "fans_status",
                                              $$v
                                            )
                                          },
                                          expression: "form.fans_status"
                                        }
                                      },
                                      _vm._l(_vm.fansStatus, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { width: "auto" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { background: "#85ce61" },
                                    attrs: { type: "success" },
                                    on: { click: _vm.output }
                                  },
                                  [_vm._v("导出")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      margin: "0 10px",
                                      display: "inline-block"
                                    },
                                    attrs: {
                                      action: _vm.importApi,
                                      "show-file-list": false,
                                      "auto-upload": true,
                                      "on-success":
                                        _vm.importSupplyApplySuccess,
                                      "with-credentials": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "trigger",
                                          type: "primary"
                                        },
                                        slot: "trigger"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    批量导入建档申请\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "success" },
                                    on: { click: _vm.handleDownExportTemplate }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  下载导入模版\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleSupplyMsg()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  新增\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        attrs: {
                          height: "800",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "sa_id",
                            label: "申请单号",
                            width: "80"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "apply_img",
                            label: "申请图片",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "80"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      _vm._l(scope.row.apply_imgs, function(
                                        item,
                                        key
                                      ) {
                                        return _c("img", {
                                          key: key,
                                          staticStyle: {
                                            "max-width": "100%",
                                            "max-height": "100%"
                                          },
                                          attrs: { src: item }
                                        })
                                      }),
                                      0
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1478720831
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "license",
                            label: "营业执照",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("img", {
                                      directives: [
                                        { name: "viewer", rawName: "v-viewer" }
                                      ],
                                      staticStyle: {
                                        "max-width": "80px",
                                        "max-height": "80px"
                                      },
                                      attrs: { src: row.license, alt: "" }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3377222549
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_video",
                            label: "视频",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    row.supply_video
                                      ? _c("video", {
                                          staticStyle: {
                                            "max-width": "80px",
                                            "max-height": "80px"
                                          },
                                          attrs: {
                                            src: row.supply_video,
                                            preload: "metadata"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleViewVideo(
                                                row.supply_video
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1226909215
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "city_name",
                            label: "城市",
                            width: "80"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "market_name",
                            label: "市场"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "child_market_name",
                            label: "子市场"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "brand_name",
                            label: "品牌名"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supplier_num",
                            label: "档口号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "subscribe_num",
                            label: "提前订阅粉丝数"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "fans_status_txt",
                            label: "粉丝状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "show_app",
                            label: "是否可提前订阅",
                            width: "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-switch", {
                                      attrs: {
                                        value: scope.row.show_app,
                                        "active-value": "1",
                                        "inactive-value": "2"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleShowApp(scope.row)
                                        }
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2836082496
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "main_styles",
                            label: "主风格"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "submit_admin_name",
                            label: "提审人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "submit_time",
                            label: "提审时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "submit_reason",
                            label: "申请原因"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "apply_status",
                            label: "状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "first_check_admin_name",
                            label: "一审人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "first_check_time",
                            label: "一审时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "first_reject_reason",
                            label: "一审驳回原因"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "second_check_admin_name",
                            label: "二审人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "second_check_time",
                            label: "二审时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "second_reject_reason",
                            label: "二审驳回原因"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_id",
                            label: "商家id"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            align: "center",
                            fixed: "right",
                            width: "160"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "bottom-wrap" },
                                      [
                                        scope.row.status !==
                                        _vm.STATUS_TYPE.CANCELLED
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "sub-bottom",
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleSupplyMsg(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "提前订阅信息修改\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.status ===
                                        _vm.STATUS_TYPE.PENDING_REVIEW_2
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.addSupply(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("创建商家")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.status ===
                                        _vm.STATUS_TYPE.CLOSED
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "sub-bottom",
                                                attrs: {
                                                  size: "mini",
                                                  type: "success"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openSupplyApply(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("开启档口")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.status ===
                                        _vm.STATUS_TYPE.COOPERATING
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "sub-bottom",
                                                attrs: {
                                                  size: "mini",
                                                  type: "danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.closeSupplyApply(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("关闭档口")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.status ===
                                        _vm.STATUS_TYPE.PENDING_REVIEW_1
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "sub-bottom",
                                                attrs: {
                                                  size: "mini",
                                                  type: "success"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.firstPass(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("通过")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.status ===
                                        _vm.STATUS_TYPE.PENDING_REVIEW_1
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "sub-bottom",
                                                attrs: {
                                                  size: "mini",
                                                  type: "danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.firstReject(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("驳回")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.status ===
                                        _vm.STATUS_TYPE.UNSUBMITTED
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleCancellation(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("作废申请")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "text"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.supplyLog(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("\n                  日志")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1682574753
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "操作日志",
                      visible: _vm.logVisible,
                      width: "70%"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.logVisible = $event
                      }
                    }
                  },
                  [
                    _vm.logData
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              { attrs: { data: _vm.logData.list } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    property: "event",
                                    label: "事件",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    property: "remark",
                                    label: "内容",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    property: "admin_name",
                                    label: "操作人",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    property: "create_time",
                                    label: "操作时间",
                                    align: "center"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "right",
                                  padding: "25px"
                                }
                              },
                              [
                                _c("el-pagination", {
                                  attrs: {
                                    "current-page": _vm.logcurPage,
                                    background: "",
                                    layout: "total, prev, pager, next, jumper ",
                                    total: _vm.logData.logpages,
                                    "page-size": 10
                                  },
                                  on: {
                                    "update:currentPage": function($event) {
                                      _vm.logcurPage = $event
                                    },
                                    "update:current-page": function($event) {
                                      _vm.logcurPage = $event
                                    },
                                    "current-change": _vm.handleCurrentChange2
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper, sizes ",
                        total: _vm.resData.pages,
                        "page-size": 10,
                        "page-sizes": [10, 50, 100, 200]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("supply-message-dialog", {
        ref: "supplyMessageRef",
        on: { "submit-success": _vm.fetchData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4da34559", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da34559","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supplyapply/SupplyApplyList.vue
// module id = null
// module chunks = 